import { ChevronLeftIcon } from '@/assets/icons/chevron-left.icon';
import Button from '@/core/design-system/Button';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { useNavigate } from 'react-router-dom';

const SecondaryHeader = () => {
  const { state, handleSubmit, openPreview, isSubmitting } = usePlayground();
  const navigate = useNavigate();

  const goToPlayground = () => {
    navigate('/playground');
  };

  const goToAnalytics = () => {
    navigate('/analytics');
  };

  return (
    <div className="flex items-center justify-between flex-col md:flex-row py-8 px-24 z-50">
      <div className="relative inline-block text-left">
        <div
          className="inline-flex w-full justify-center gap-x-2 text-sm font-semibold text-gray-900"
          onClick={goToPlayground}
        >
          <ChevronLeftIcon className="-mr-1 h-5 w-5 text-[#525760]" />
          <p className="text-light font-bold cursor-pointer">Back to Linkie</p>
        </div>
      </div>

      <div className="flex md:grid grid-cols-3 gap-4 justify-center items-center mt-4 md:mt-0">
        <Button type="button" variant="outlined" color="secondary" onClick={goToAnalytics}>
          Analytics
        </Button>
        <Button type="button" variant="outlined" color="secondary" onClick={openPreview}>
          Preview
        </Button>
        <Button
          type="button"
          className="md:w-20"
          onClick={handleSubmit}
          disabled={state.actions.length === 0 || isSubmitting}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SecondaryHeader;
